export default __webpack_public_path__ + "static/media/ebook-box-image-02.8bf05f5c.png";